import React from 'react'
import { connect } from 'react-redux'
import { debounce, get } from 'lodash'

import { fetchStaffs, deleteStaff } from '../../actions/remote_api'
import StaffTable from './StaffTable'

class StaffTableContainer extends React.Component {
  abortController = null

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleDataChange = (filter) => {
    this.abortInFlights()
    this.abortController = new AbortController()

    this.props.fetchStaffs(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        ...this.createQueryFilter(filter.query),
      },
      {
        signal: this.abortController.signal,
      },
    )
  }

  createQueryFilter = (filter) => {
    if (!filter) return undefined

    const queryfilter = {}
    if (filter.code) queryfilter.code_like = filter.code
    if (filter.firstName) queryfilter.firstName_like = filter.firstName
    if (filter.lastName) queryfilter.lastName_like = filter.lastName
    if (filter.gender) queryfilter.gender = filter.gender
    if (filter.email) queryfilter.email_like = filter.email
    return queryfilter
  }

  render() {
    return <StaffTable {...this.props} onDataChange={this.handleDataChange} />
  }
}

export default connect(
  ({ fetch }) => ({
    isLoading: get(fetch, 'staff.isLoading.list', false),
    instances: get(fetch, 'staff.list', []),
    totalCount: get(fetch, 'staff.totalCount'),
  }),
  { fetchStaffs, deleteInstance: deleteStaff },
)(StaffTableContainer)
